import { type GenericMap } from "@common/declarations";
import { usePrevious } from "@common/lib/hooks";
import { parseQueryString, toQueryString } from "@common/lib/url";
import { isEqual } from "lodash";
import React from "react";
import { useParams, useSearchParams } from "react-router-dom";

export let urls: NavigationUrls = {
  order: {
    detail: null
  },
  subscription: {
    detail: null
  }
};
export type NavigationUrls = {
  order: {
    detail: null | ((id: string) => string);
  };
  subscription: {
    detail: null | ((id: string) => string);
  };
};
export type Navigation = {
  init: (urls?: NavigationUrls) => void;
};

export const init = (navigationUrls?: NavigationUrls) => {
  if (navigationUrls) {
    urls = navigationUrls;
  }
};

type SetQueryOptions = {
  arrayMode?: "json" | "repeat";
  isReplace?: boolean;
};

export const useNavigation = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setQuery = (query: GenericMap<any>, opts?: SetQueryOptions) => {
    const finalQuery = {
      returnUrl: query.returnurl ?? searchParams["returnUrl"], // could be lowercased
      ...query
    };
    setSearchParams(toQueryString(finalQuery), {
      replace: opts?.isReplace
    });
  };

  return {
    setQuery,
    upsertQs: (key: string, id?: string | null, isReplace?: boolean) => {
      const query = parseQueryString();
      if (query[key] === id) return;

      query[key] = id || undefined;
      setQuery(query, { isReplace });
    },
    urls
  };
};

export const useRouteParams = (): GenericMap<string | undefined> => {
  const newParams = useParams();
  const [params, setParams] = React.useState(newParams);
  const previousParams = usePrevious(params);

  React.useEffect(() => {
    if (!!previousParams && !isEqual(previousParams, newParams)) setParams(newParams);
  }, [previousParams, newParams]);

  return params;
};
